import React from "react";
import OrderTable from "@commons/orders/Table";

const Orders = ({ storeId }: { storeId: number }) => {
  return (
    <OrderTable type="All" initialFilters={{ storeId: String(storeId) }} />
  );
};

export default Orders;
